/**
 * Module Federation Bootstrap
 *
 * This file dynamically imports the bootstrap to ensure shared modules (like Vue)
 * are loaded asynchronously as required by Module Federation.
 */

// Import bootstrap dynamically but also ensure the container is initialized
import('./bootstrap').catch((err) => console.error('Error importing bootstrap:', err));
